import { useState, useCallback } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useStatusMessage } from '../../components';
import { createSharedTasks } from '../../utilities/Database.mjs';
import { fullUrlForSharedTasks } from '../../fleet-shared/Urls.mjs';

const stateShowChoices = 0;
const stateCreatingLink = 1;
const stateShowLink = 2;

function ChoicesBody({ onCreateLink, entries }) {
  const hasEntries = entries && entries.length > 0;

  return (
    <div className="text-center">
      <p>Share a read-only snapshot of {hasEntries ? entries.length : 'your'} task{(!hasEntries || entries.length !== 1) ? 's' : ''} with anyone who has a TaskPogo account.</p>
      <button
        className='btn btn-primary'
        onClick={onCreateLink}
        disabled={!hasEntries}
      >
        <i className="fa-solid fa-link me-2"></i>
        Create Shareable Link
      </button>
      {!hasEntries && <p className="text-muted mt-2">No tasks loaded to share.</p>}
    </div>
  );
}

function LinkBody({ shareUrl, copied, onCopy }) {
  return (
    <div>
      <p>Anyone with a TaskPogo account can view these tasks using this link:</p>
      <div className="input-group mb-3">
        <input
          type="text"
          className="form-control"
          value={shareUrl}
          readOnly
          onClick={(e) => e.target.select()}
        />
        <button className="btn btn-primary" onClick={onCopy}>
          <i className={`fa-regular ${copied ? 'fa-check' : 'fa-clipboard'} me-1`}></i>
          {copied ? 'Copied!' : 'Copy'}
        </button>
      </div>
      <p className="text-muted small">This link shares a snapshot of the tasks as they are right now.</p>
    </div>
  );
}

export function ShareTasks({ show, onHide, entries, itemId, itemName, listType }) {
  const [StatusMessage, { showError, hideStatus }] = useStatusMessage();
  const [state, setState] = useState(stateShowChoices);
  const [shareUrl, setShareUrl] = useState('');
  const [copied, setCopied] = useState(false);

  const handleClose = useCallback(() => {
    setState(stateShowChoices);
    setShareUrl('');
    setCopied(false);
    hideStatus();
    onHide();
  }, [onHide, hideStatus]);

  const handleCreateLink = useCallback(async () => {
    try {
      setState(stateCreatingLink);
      const shared = await createSharedTasks(itemId, itemName, listType, entries);
      const url = fullUrlForSharedTasks(shared.id);
      setShareUrl(url);
      setState(stateShowLink);
    } catch (err) {
      showError(err);
      setState(stateShowChoices);
    }
  }, [itemId, itemName, listType, entries, showError]);

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      showError('Failed to copy to clipboard');
    }
  }, [shareUrl, showError]);

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Share Tasks</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <StatusMessage />
        {state === stateShowChoices && (
          <ChoicesBody onCreateLink={handleCreateLink} entries={entries} />
        )}
        {state === stateCreatingLink && (
          <div className="text-center text-primary">
            <i className="fa fa-spinner fa-spin me-2"></i>
            Creating link...
          </div>
        )}
        {state === stateShowLink && (
          <LinkBody shareUrl={shareUrl} copied={copied} onCopy={handleCopy} />
        )}
      </Modal.Body>
    </Modal>
  );
}
